import { render, staticRenderFns } from "./ListUserLabel.vue?vue&type=template&id=883f4d58"
import script from "./ListUserLabel.vue?vue&type=script&lang=js"
export * from "./ListUserLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports